import React, { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { authProvider } from './authProvider';
import { performLogout } from './utils/logout';

export default function Home() {
  const navigate = useNavigate();

  // Wipe the invalid session on mount so a refresh recovers instead of re-denying.
  useEffect(() => {
    try { localStorage.clear(); } catch (e) { /* storage unavailable */ }
  }, []);

  // Manual "Back to login": clear local session + sign out of MSAL so the next
  // sign-in doesn't silently re-pick the denied account.
  const login = () => performLogout(authProvider, null, navigate);

  return (
    <div id="wrapper " className="access-bg">
         {/* ======= Header ======= */}
         <header id="header" className="fixed-top dark-bg ">
              <div className="container">
                {/* <h1 className="logo me-auto"><a href="index.html">Arsha</a></h1> */}
                {/* Uncomment below if you prefer to use an image logo */}
                <div className='row'>
                  <div className='col-lg-6'>
                    <a href="/" class="logo me-auto"><img src="assets/img/logo.png" alt="" class="img-fluid logo-img"/></a>                
                  </div>
                  <div className='col-lg-6'>                    
                    {/* <a href="#login" className="btn-login" onClick={login}>Login/Signup</a>              */}
                  </div>
                </div>
              </div>
            </header>{/* End Header */}
            {/* ======= Hero Section ======= */}
     <div className="login__wrapper">
      {/* <LoginHeader heading=""/> */}
        <section className="login__section">
          <div className="row">
          <div class="center-screen">
        <div className="access-denied">
              <img className="denied-img" src="./assets/img/protection.png" alt=""/>
                <p className="access-txt">You are not authorized to access this website.</p>
                 <p className="access-txt-para">It looks like you do not have the necessary permissions to view this content. This may be because you are not associated with any company in our system.</p>
                 <button className="btn google__btn" onClick={login}>
                   Back to login
                 </button>
               </div>
              </div>
            </div>
        </section>
      </div>
    </div>
  
  );
}
